const _APP = "cloki-query";
const _HISTORY_ITEM = _APP + "-history-item";
const _TIMERANGE_ITEM = _APP + "-time-range-item";
const _CHART_ITEM = _APP + "-chart-item";
const _LABELS_ITEM = _APP + '-labels-item';
const _URL_ITEM = _APP + "-url-item";
const _QUERY_ITEM = _APP + "-url-item";

module.exports = {
    _HISTORY_ITEM,
    _CHART_ITEM,
    _LABELS_ITEM,
    _TIMERANGE_ITEM,
    _URL_ITEM,
    _QUERY_ITEM
}
